export default __webpack_public_path__ + "ad80427b5a2980f1d19884ede42b29de.svg";